module.exports = __webpack_public_path__ + "img/icon16.10e2824e.png";